import React from 'react';
import { Header } from '@gasbuddy/react-components';

export default function FormHeader(props) {
  return (<Header size="sm" {...props} />);
}
